import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Fixed from "./components/Fixed";
/* PAGES */
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import SolarPlant from "./pages/SolarPlant";
import Stp from "./pages/Stp";
import Etp from "./pages/Etp";
import BioGas from "./pages/BioGas";
import Energy from "./pages/Energy";
import Green from './pages/Green';
import Enivronment from "./pages/Environment";
import NotFound from "./pages/NotFound";

function App() {

  /* AOS INITIALIZATION */
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,    // animation runs every scroll
      mirror: true,  // animate on scroll up
      offset: 120,   // better trigger timing
    });
  }, []);

  return (
    <BrowserRouter>
    <Fixed/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/SolarPlant" element={<SolarPlant />} />
        <Route path="/Stp" element={<Stp />} />
        <Route path="/Etp" element={<Etp />} />
        <Route path="/BioGas" element={<BioGas />} />
        <Route path="/Energy" element={<Energy />} />
        <Route path="/Green" element={<Green />} />
        <Route path="/Enivronment" element={<Enivronment />} />
        <Route path="/Gallery" element={<Gallery />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Privacy" element={<Privacy />} />
        <Route path="/Terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
